import DepartmentDialog from './src/Index.vue'
export default DepartmentDialog
